/**
 * Function to wait for a cookie in the browser storage, and if the cookie is found, a callback is runned.
 * @param {String} cookieName name of the cookie to wait for
 * @param {Number} timeout value in ms, total of time to iterate in checkFrecuency for the cookie
 * @param {Number} frecuencyCheck value in ms, frecuency time to check for the cookie before timeout is reached
 * @param {Function} callback code to run after find the cookie, if the cookie is reached. Recieve as arg the cookie value.
 */
export default function waitUniqueCookie(
  cookieName,
  timeout,
  frecuencyCheck,
  callback,
) {
  const t0 = performance.now();
  const loopInterval = setInterval(detectCookie, frecuencyCheck);

  /**
   * Function to detect cookie inside the interval
   */
  function detectCookie() {
    const t1 = performance.now();
    if (t1 - t0 <= timeout) {
      const cookieStorage = new window.proxyStorage.WebStorage('cookieStorage');

      const cookieValue = cookieStorage.getItem(cookieName);
      if (cookieValue !== null) {
        clearInterval(loopInterval);
        callback(cookieValue);
      }
    } else {
      clearInterval(loopInterval);
    }
  }
}
